import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import truncate from "lodash/truncate";
import { TruncateOptions } from "lodash";
import { Batch, BatchStatus } from "@wingspanhq/wingspan-api-sdk";

type Args = {
  batch?: Batch;
  /** Singular noun for what the batch imports, e.g. "Payable", "Contractor". */
  entityLabel: string;
  truncateOptions?: TruncateOptions;
};

/**
 * Name of the spreadsheet uploaded into the batch. A batch that has already
 * left `Created` keeps a placeholder so the details page never renders a blank
 * heading for an import that did happen.
 */
export const selectorImportBatchUploadedFilename = (args: Args): string => {
  const rawFilename =
    args.batch?.metadata?.[BATCH_LABELS_WS_KEYS.bulkImporterFilename];
  const filename = args.truncateOptions
    ? truncate(rawFilename, args.truncateOptions)
    : rawFilename;

  if (args.batch?.status === BatchStatus.CREATED) {
    return filename || "";
  }

  return filename || `Unnamed ${args.entityLabel} Batch`;
};
